var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageWrapper", {
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: _vm.getIsMobile ? 24 : 12 } },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "formRef",
                        staticClass: "company-info_form",
                        attrs: {
                          inline: false,
                          "label-position": _vm.getIsMobile ? "top" : "right",
                          model: _vm.form,
                          "label-width": "120px",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "客户公司", prop: "dscompany" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入客户公司" },
                              nativeOn: {
                                click: function ($event) {
                                  _vm.dialog = true
                                },
                              },
                              model: {
                                value: _vm.form.dscompany,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "dscompany", $$v)
                                },
                                expression: "form.dscompany",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "部门", prop: "dsbumen" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入部门" },
                              model: {
                                value: _vm.form.dsbumen,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "dsbumen", $$v)
                                },
                                expression: "form.dsbumen",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "接收人", prop: "dsname" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入接收人" },
                              model: {
                                value: _vm.form.dsname,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "dsname", $$v)
                                },
                                expression: "form.dsname",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "电话", prop: "dstel" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入电话" },
                              model: {
                                value: _vm.form.dstel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "dstel", $$v)
                                },
                                expression: "form.dstel",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "传真", prop: "dsmax" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入传真" },
                              model: {
                                value: _vm.form.dsmax,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "dsmax", $$v)
                                },
                                expression: "form.dsmax",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "邮箱", prop: "dsemail" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入邮箱" },
                              model: {
                                value: _vm.form.dsemail,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "dsemail", $$v)
                                },
                                expression: "form.dsemail",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.getIsMobile ? 24 : 12 } },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "quoteFormRef",
                        staticClass: "company-info_form",
                        attrs: {
                          inline: false,
                          "label-position": _vm.getIsMobile ? "top" : "right",
                          model: _vm.quoteForm,
                          "label-width": "120px",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "报价公司", prop: "cname" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入报价公司" },
                              model: {
                                value: _vm.quoteForm.cname,
                                callback: function ($$v) {
                                  _vm.$set(_vm.quoteForm, "cname", $$v)
                                },
                                expression: "quoteForm.cname",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "部门", prop: "bumen" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入部门" },
                              model: {
                                value: _vm.quoteForm.bumen,
                                callback: function ($$v) {
                                  _vm.$set(_vm.quoteForm, "bumen", $$v)
                                },
                                expression: "quoteForm.bumen",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "发送人", prop: "rname" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "发送人" },
                              model: {
                                value: _vm.quoteForm.rname,
                                callback: function ($$v) {
                                  _vm.$set(_vm.quoteForm, "rname", $$v)
                                },
                                expression: "quoteForm.rname",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "电话", prop: "tel" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入电话" },
                              model: {
                                value: _vm.quoteForm.tel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.quoteForm, "tel", $$v)
                                },
                                expression: "quoteForm.tel",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "传真", prop: "max" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入传真" },
                              model: {
                                value: _vm.quoteForm.max,
                                callback: function ($$v) {
                                  _vm.$set(_vm.quoteForm, "max", $$v)
                                },
                                expression: "quoteForm.max",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "QQ", prop: "qq" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入QQ" },
                              model: {
                                value: _vm.quoteForm.qq,
                                callback: function ($$v) {
                                  _vm.$set(_vm.quoteForm, "qq", $$v)
                                },
                                expression: "quoteForm.qq",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("Model", { ref: "modelRef", attrs: { data: _vm.modelData } }),
            _c(
              "div",
              {
                staticClass: "footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c("el-button", { on: { click: _vm.handleReset } }, [
                  _vm._v("重 置"),
                ]),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleSubmit },
                  },
                  [_vm._v("生成报价单")]
                ),
              ],
              1
            ),
            _vm.dialog
              ? _c(
                  "el-dialog",
                  {
                    attrs: {
                      visible: _vm.dialog,
                      title: "选择报价公司",
                      width: _vm.getIsMobile ? "100%" : "50%",
                      "append-to-body": true,
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.dialog = $event
                      },
                    },
                  },
                  [
                    _c("QuotationCompany", {
                      on: { selectedCompany: _vm.getSelectedCompany },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }